import { render, staticRenderFns } from "./orderSerCharge.vue?vue&type=template&id=89dfab50&scoped=true&"
import script from "./orderSerCharge.vue?vue&type=script&lang=js&"
export * from "./orderSerCharge.vue?vue&type=script&lang=js&"
import style0 from "./orderSerCharge.vue?vue&type=style&index=0&id=89dfab50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dfab50",
  null
  
)

export default component.exports